import ImportScreen from "~/components/import/ImportScreen";
import { Permission } from "~/hooks/permissions";
import PermissionOrWarn from "~/components/common/PermissionOrWarn";

import {
  CREATE_PATIENT_DATA_IMPORT,
  GET_PATIENT_DATA_IMPORT_PREVIEW,
  DELETE_PATIENT_DATA_IMPORT,
  GET_PATIENT_DATA_IMPORT,
  EXECUTE_PATIENT_DATA_IMPORT,
} from "~/components/import/graphqlQueries";

export default function PatientImport() {
  return (
    <PermissionOrWarn permission={Permission.importPatients}>
      <ImportScreen
        resourceType={"PATIENT"}
        title={"Import Patients"}
        gql={{
          createImport: CREATE_PATIENT_DATA_IMPORT,
          deleteImport: DELETE_PATIENT_DATA_IMPORT,
          executeImport: EXECUTE_PATIENT_DATA_IMPORT,
          listImports: GET_PATIENT_DATA_IMPORT,
          previewImport: GET_PATIENT_DATA_IMPORT_PREVIEW,
        }}
        exampleColumnNamesAndTitles={[
          {name: "firstName", title: "First name"},
          {name: "lastName", title: "Last name"},
          {name: "dateOfBirth", title: "Date of birth"},
          {name: "phone", title: "Phone"},
          {name: "identifierType", title: "ID Type"},
          {name: "identifier", title: "ID"},
          {name: "sex", title: "Sex"},
          {name: "preferredLanguage", title: "Language"},
          {name: "addressStreet", title: "Address"},
          {name: "addressLineTwo", title: ""},
          {name: "addressCity", title: "City"},
          {name: "addressState", title: "State"},
          {name: "addressZip", title: "Zip"},
        ]}
        errorColumnNamesAndTitles={[
          {name: "firstName", title: "First name"},
          {name: "lastName", title: "Last name"}
        ]}
      />
    </PermissionOrWarn>
  )
}
